import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {IoniconsFilled} from '@pt/pt-models';

@Component({
  selector: 'pt-scrollable-nav-tab',
  templateUrl: './scrollable-nav-tab.component.html',
  styleUrls: ['./scrollable-nav-tab.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ScrollableNavTabComponent implements OnInit, OnChanges {

  @Input() navTabs;
  @Input() STEP = 200;
  @Input() mode: 'AROUND' | 'FLOAT_RIGHT' = 'FLOAT_RIGHT';

  public IconArrowLeft = IoniconsFilled.caretLeft;
  public IconArrowRight = IoniconsFilled.caretRight;
  public showArrows = true;
  public disableLeftArrow = false;
  public disableRightArrow = false;
  public NAV_SCROLL_ID = 'navTabScroll';

  ngOnInit() {
    //todo @Georgy capire come controllare se far vedere o meno la frecce di scroll
    // this.checkArrowVisibility(this.navTabs);
    // this.scrollTab(this.navTabs, -this.STEP);
    this.setDisableLeftArrow(this.navTabs);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.navTabs) {
      //todo @Georgy capire come controllare se far vedere o meno la frecce di scroll
    }
  }

  scrollTab(navTabs, value: number) {
    navTabs.scrollLeft = navTabs.scrollLeft + value;
    this.checkArrowVisibility(navTabs);
    this.setDisableLeftArrow(navTabs);
    this.setDisableRightArrow(navTabs);
  }

  checkArrowVisibility(navTabs) {
    if (navTabs) {
      this.showArrows = navTabs?.scrollWidth > navTabs?.offsetWidth;
      this.setDisableLeftArrow(navTabs);
    } else {
      this.showArrows = true;
    }
  }

  setDisableLeftArrow(navTabs) {
    this.disableLeftArrow = navTabs.scrollLeft === 0;
  }

  setDisableRightArrow(navTabs) {
    this.disableRightArrow = navTabs.scrollLeft === (navTabs.scrollWidth - navTabs.offsetWidth);
  }

}
